import { createAction } from '@ngrx/store';

const loadUser = createAction('[Is Logged In Guard] Load user');

export const IsLoggedInGuardActions = {
  loadUser,
};
